import React, { useEffect, useState } from 'react';
import { AlertCircle, UserCheck, UserX, RefreshCw } from 'lucide-react';

function formatDato(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('da-DK', { day: 'numeric', month: 'short', year: 'numeric' });
}

export default function ChurnReaktiveringPanelIV() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('/api/os/vaekst/churn-reaktivering', { credentials: 'include' })
      .then(r => r.ok ? r.json() : Promise.reject(r.statusText))
      .then(d => { setData(d); setLoading(false); })
      .catch(e => { setError(String(e)); setLoading(false); });
  }, []);

  if (loading) return <div style={{ color: '#9ca3af', padding: 24 }}>Henter churn-data...</div>;
  if (error) return <div style={{ color: '#ef4444', padding: 24, display: 'flex', alignItems: 'center', gap: 8 }}><AlertCircle size={16} /> {error}</div>;

  const { aktive, lukkede_90d, churn_rate_pct, reaktiverbare } = data;

  const kpiKort = [
    { icon: <UserCheck size={18} color="#22c55e" />, label: 'Aktive klienter', value: aktive, color: '#22c55e' },
    { icon: <UserX size={18} color="#ef4444" />, label: 'Lukkede (90d)', value: lukkede_90d, color: '#ef4444' },
    { icon: <RefreshCw size={18} color="#f59e0b" />, label: 'Churn-rate/md', value: `${churn_rate_pct}%`, color: churn_rate_pct > 5 ? '#ef4444' : '#22c55e' },
  ];

  return (
    <div style={{ width: '100%' }}>
      {/* KPI-kort */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 20 }}>
        {kpiKort.map((k, i) => (
          <div key={i} style={{ flex: 1, minWidth: 140, background: 'rgba(255,255,255,0.05)', borderRadius: 10, padding: '14px 16px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
              {k.icon}
              <span style={{ color: '#9ca3af', fontSize: 12 }}>{k.label}</span>
            </div>
            <div style={{ color: k.color, fontSize: 24, fontWeight: 700 }}>{k.value}</div>
          </div>
        ))}
      </div>

      {/* Minitragt */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
        {[
          { label: 'Aktive', val: aktive, color: '#22c55e' },
          { label: 'arr' },
          { label: 'Lukkede', val: lukkede_90d, color: '#ef4444' },
          { label: 'arr' },
          { label: 'Re-aktiverbare', val: reaktiverbare?.length || 0, color: '#f59e0b' },
        ].map((item, i) => item.label === 'arr'
          ? <span key={i} style={{ color: '#6b7280', fontSize: 18 }}>&rarr;</span>
          : <div key={i} style={{ background: `${item.color}22`, border: `1px solid ${item.color}44`, borderRadius: 8, padding: '8px 14px', textAlign: 'center', minWidth: 100 }}>
              <div style={{ color: item.color, fontSize: 18, fontWeight: 700 }}>{item.val}</div>
              <div style={{ color: '#9ca3af', fontSize: 11 }}>{item.label}</div>
            </div>
        )}
      </div>

      {/* Note */}
      <div style={{ color: '#f59e0b', fontSize: 12, marginBottom: 12, padding: '8px 12px', background: 'rgba(245,158,11,0.08)', borderRadius: 6, border: '1px solid rgba(245,158,11,0.2)' }}>
        5-10% hit rate = gratis vaekst via re-aktivering
      </div>

      {/* Liste */}
      {reaktiverbare && reaktiverbare.length > 0 ? (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
                {['Klient', 'Sidst aktiv', 'Dage siden', 'Handling'].map(h => (
                  <th key={h} style={{ textAlign: 'left', padding: '8px 12px', color: '#9ca3af', fontWeight: 500 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {reaktiverbare.slice(0, 15).map(k => (
                <tr key={k.id} style={{ borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                  <td style={{ padding: '12px 12px', color: '#ffffff' }}>{k.navn}</td>
                  <td style={{ padding: '12px 12px', color: '#9ca3af' }}>{formatDato(k.sidst_aktiv)}</td>
                  <td style={{ padding: '12px 12px', color: k.dage_siden_aktiv > 60 ? '#ef4444' : '#f59e0b' }}>{k.dage_siden_aktiv}d</td>
                  <td style={{ padding: '12px 12px' }}>
                    <a href={/klienter/} style={{ color: '#3b82f6', textDecoration: 'none', fontSize: 12, padding: '6px 10px', background: 'rgba(59,130,246,0.15)', borderRadius: 5, border: '1px solid rgba(59,130,246,0.3)' }}>
                      Kontakt
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div style={{ color: '#6b7280', fontSize: 13, textAlign: 'center', padding: 24 }}>
          Ingen re-aktiverbare klienter fundet
        </div>
      )}
    </div>
  );
}